/* eslint-disable react-hooks/exhaustive-deps */
import { Button, createStyles, FormGroup, Grid, InputAdornment, makeStyles, TextField, Theme } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { FormApi } from 'final-form';
import gql from 'graphql-tag';
import React, { useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-apollo';
import { AnyObject, Field, Form, FormSpy } from 'react-final-form';
import { showNotification } from '../../App';
import { RvLoader } from '../../components/Loader';
import { LightTooltip } from '../../helpers/commonHelper';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flex: 1,
            flexFlow: 'column',
            padding: '0 30px',
        },
        textField: {
            width: '100%'
        },
        buttonWrapper: {
            margin: '0 -10px',
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            '& > button': {
                margin: '0 10px',
            }
        },
        loaderWrapper: {
            display: 'flex',
            justifyContent: 'center',
            flex: 1,
        },
        formGroup: {
            alignItems: 'flex-start',
            width: '100%',
            '& .MuiFormControlLabel-root': {
                marginLeft: 0,
            }
        },
        infoIcon: {
            color: '#1565c0',
            fontSize: 20,
        }
    })
);

interface FormState {
    leadMatterType: string | null;
}
interface DataFieldMappingsSettingsTabState {
    isLoading: boolean;
    isFormChanged: boolean;
    onSubmitLoading: boolean;
}

export default function DataFieldMappingsSettingsTab() {

    const classes = useStyles();

    const [state, setState] = useState<DataFieldMappingsSettingsTabState>({
        isLoading: true,
        isFormChanged: false,
        onSubmitLoading: false,
    });


    const [formState, setFormState] = useState<FormState>({
            leadMatterType: null,
        });

    // tslint:disable-next-line: no-any
    const [uodateDataFieldMappingsMutation] = useMutation<any, DataFieldMappingsSettingsMutationParams>(DATA_FIELD_MAPPINGS_SETTINGS_MUTATION);
    const dataFieldMappingsSettings = useQuery<DataFieldMappingsSettingsData>(DATA_FIELD_MAPPINGS_SETTINGS_QUERY);

    useEffect(() => {
        if (!dataFieldMappingsSettings.loading && dataFieldMappingsSettings.data) {
            var leadMatterType = dataFieldMappingsSettings.data?.settings.applications.dataFieldMappingsSettings.config.leadMatterType;

             setFormState((prevFormState) => {
                return {
                    ...prevFormState,
                    leadMatterType: leadMatterType
                };
            });

            setState((prevState) => {
                return {
                    ...prevState,
                    isLoading: false
                };
            });
        }
    }, [dataFieldMappingsSettings.data, dataFieldMappingsSettings.loading])

    // tslint:disable-next-line: no-any
    const onFormValueChanged = (changeProps: any) => {
        if (!changeProps.pristine) {
            setState((prevState) => {
                return {
                    ...prevState,
                    isFormChanged: true
                };
            });
        }
    };

    // tslint:disable-next-line: no-any
    // const required = (value: any) => {
    //     return value ? undefined : 'Required';
    // };

    const onReset = (form: FormApi<FormState>) => () => {
        form.setConfig('keepDirtyOnReinitialize', false);
        form.batch(() => {
            form.reset();
        });
        form.setConfig('keepDirtyOnReinitialize', true);
    };

    const onSubmit = (form: FormApi<FormState>, values: AnyObject) => {
        setState((prevState) => {
            return {
                ...prevState,
                onSubmitLoading: true,
            };
        });

        uodateDataFieldMappingsMutation({
            variables: {
                leadMatterType: values.leadMatterType
            }
        }).then((results: {data :any}) => {
            if (results.data) {
                showNotification(null, 'Successfully submitted', 'info');    

                form.setConfig('keepDirtyOnReinitialize', false);

                const tempInitial: FormState = {
                    leadMatterType: values.leadMatterType,
                };

                form.batch(() => {
                    form.reset(tempInitial);
                });

                form.setConfig('keepDirtyOnReinitialize', true);
                
                setState((_prevState) => {
                    return {
                        ..._prevState,
                        onSubmitLoading: false
                    };
                });
            }
        }).catch((reason: any) => {
            showNotification('Failed to update marketing settings', reason, 'error');
            setState((_prevState) => {
                return {
                    ..._prevState,
                    onSubmitLoading: false
                };
            });
        });;
    };

    return (
        <div className={classes.root}>
            {state.isLoading ? (
                <div className={classes.loaderWrapper}>
                    <RvLoader />
                </div>
            ) : (
                <Form
                    onSubmit={(values, form: FormApi<FormState>) => onSubmit(form, values)}  
                    initialValues={formState}
                    initialValuesEqual={() => true}
                    keepDirtyOnReinitialize={true}
                    subscription={{
                        submitting: true,
                        pristine: true
                    }}
                    render={({
                        handleSubmit,
                        form,
                        submitting,
                        pristine,
                        values
                    }) => (
                            <form onSubmit={handleSubmit} id="DataFieldMappingsSettingsTab">
                                <FormSpy 
                                    subscription={{ pristine: true }}
                                    // tslint:disable-next-line: no-shadowed-variable
                                    onChange={props => {
                                        onFormValueChanged(props);
                                    }}
                                />
                                
                                <Grid container={true} spacing={3}>
                                    <Grid item={true} xs={12} md={12} lg={12} justify="flex-start">
                                        <FormGroup
                                            className={classes.formGroup}
                                        >
                                            <Field
                                                name="leadMatterType"
                                                allowNull={true}
                                                md
                                                // validate={form.getFieldState('timeOfDay')?.value !== null ? required : undefined}
                                            >
                                                {({ input, meta }) => (
                                                    <TextField
                                                        {...input}
                                                        label="Lead Matter Type"
                                                        error={meta.error && meta.touched}
                                                        helperText={meta.error && meta.touched ? meta.error : ''}
                                                        size="medium"
                                                        type="text"
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <LightTooltip
                                                                        arrow={true}
                                                                        title="The field is used to define the matter type or types that the host PMS uses to define lead or new enquiry matters. Matters of these types are excluded for new matter charts in RedView Acuity and in the matter summary list."
                                                                    >
                                                                        <InfoOutlinedIcon className={classes.infoIcon} />
                                                                    </LightTooltip>
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                    />
                                                )}
                                            </Field>
                                        </FormGroup>
                                    </Grid>
                                    <Grid item={true} xs={12} md={12} justify="flex-end">
                                        <div className={classes.buttonWrapper}>
                                            <Button 
                                                variant="outlined" 
                                                color="primary"
                                                type="submit"
                                                disabled={submitting || pristine || state.onSubmitLoading}
                                            >
                                                Save
                                            </Button>
                                            <Button 
                                                variant="outlined" 
                                                color="primary"
                                                type="button"
                                                disabled={submitting || pristine}
                                                onClick={onReset(form)}
                                            >
                                                Reset
                                            </Button>
                                        </div>
                                    </Grid>
                                    {/* {printJson(values)} */}
                            </Grid>
                            </form>
                        )}
                />
            )}
        </div>
    );
}

// tslint:disable-next-line: no-any
export function printJson(values: any) {
    if (values) {
        return (
            <>
                <pre>
                    {JSON.stringify(values, undefined, 2)}
                </pre>
            </>
        );
    } else {
        return (
            <>
                <FormSpy subscription={{ values: true }}>
                    {/* tslint:disable-next-line: no-shadowed-variable */}
                    {({ values }) => (
                        <pre>
                            {JSON.stringify(values, undefined, 2)}
                            {/* <RenderCount /> */}
                        </pre>
                    )}
                </FormSpy>
            </>
        );
    }
}

interface DataFieldMappingsSettingsData {
    settings: Settings;
}

interface Settings {
    applications: Applications;
}

interface Applications {
    id: number;
    dataFieldMappingsSettings: DataFieldMappingsSettings;
}


interface DataFieldMappingsSettings {
    id: number;
    config: Config;
}

interface Config {
    leadMatterType: string | null;
}

const DATA_FIELD_MAPPINGS_SETTINGS_QUERY = gql`
    query DataFieldMappingsSettings {
        settings {
            id
            applications {
                id
                dataFieldMappingsSettings {
                    config {
                        leadMatterType
                    }
                }
            }
        }
    }
`

interface DataFieldMappingsSettingsMutationParams {
    leadMatterType: string | null;
}

const DATA_FIELD_MAPPINGS_SETTINGS_MUTATION = gql`
    mutation UpdateDataFieldMappings ($leadMatterType: String) {
        applicationSettings {
            dataFieldMappingsSettings {
                update (leadMatterType: $leadMatterType) {
                    error
                    status
                }
            }
        }
    }
`;